import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router';
import {Dropdown} from 'react-bootstrap';
import Box from '@mui/material/Box';
import {} from '@mui/material';
import {Link} from 'react-router-dom';

import Alert, {useAlert} from 'components/snacks/Alert';

import {classIcon, numSeperator} from 'utils/DataBase';
import Loading from 'layout/Loading';
import {getServiceOrder} from "api/Api";
import Data from "utils/Data";

const ServerOrder = () => {
    const location = useLocation();
    const [product, setProduct] = useState([
        {product_id: null, title: null, cat_id: null}
    ]);
    const [validList, setValidList] = useState([]);
    const [attrList, setAttrList] = useState([]);
    const [order, setOrder] = useState({});
    const [attrLen, setAttrLen] = useState(0);
    const [validityRatio, setValidityRatio] = useState(1);
    const [validListItem, setValidListItem] = useState([]);
    const [validListItem1, setValidListItem1] = useState([
        {validity_id: null, title: null, price: 0, ratio: 1}
    ]);
    const [loading, setLoading] = useState(false);
    const [sum, setSum] = useState(0);
    const [productPrice, setProductPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [validSt, setValidSt] = useState([{title: null, price: 0}]);
    const [attrSt, setAttrSt] = useState([]);
    const [locale, setLocale] = useState('ir');
    const [isSetId, setIsSetId] = useState(false);
    const [alertMassage, setAlertMassage] = useState('');

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const saveInfo = () => {
        localStorage.setItem('product', JSON.stringify(product));
        localStorage.setItem('validList', JSON.stringify(validListItem1));
        localStorage.setItem('attrList', JSON.stringify(validListItem));
        localStorage.setItem('ratio', validityRatio);
        localStorage.setItem('sum', JSON.stringify(sumCalculate(validityRatio)));
        localStorage.setItem('location', JSON.stringify(product[0].cat_id));
        if (!order.can_pay_now){
            localStorage.setItem('cant_pay', true)
        }else{
            localStorage.setItem('cant_pay', false)
        }
    };
    const cardStorage = () => {
        if (
            JSON.parse(localStorage.getItem('product')) === null &&
            JSON.parse(localStorage.getItem('validList')) === null &&
            JSON.parse(localStorage.getItem('attrList')) === null &&
            JSON.parse(localStorage.getItem('sum')) === null
        ) {
            return false;
        } else return true;
    };

    const validItemClick = (e, id, price, ratio) => {
        setValidListItem1(() => [
            {
                validity_id: id,
                title: e.target.innerHTML,
                price: price,
                ratio: ratio
            }
        ]);
        setProductPrice(price)
        setValidSt([{
            title: e.target.innerHTML,
            price: price
        }])
        setValidityRatio(ratio)
        setTimeout(() => {

        }, 1000)
        setTotalPrice(sumCalculate(ratio) + price)

        // localStorage.removeItem('validList');
    };
    const sumCalculate = (ratio = 1) => {
        const n = validListItem ? [...validListItem] : [];
        const s = n.reduce((accumulator, object) => {
            const r = attrList.find((e) => e.title === object.attr_name)
            // return (accumulator + object.price) * (r.type !== 1 ? ratio : 1);
            return accumulator + (object.price * (r.type !== 1 ? ratio : 1));
        }, 0);
        return s;
    }
    const attrItemClick = (
        e,
        id,
        option_id,
        attr_name,
        name,
        price,
        price_text
    ) => {
        const newList = validListItem ? [...validListItem] : [];
        let ind = newList.findIndex((item) => item.id === id);

        newList[ind].price = price;
        newList[ind].option_id = option_id;
        newList[ind].name = name;
        newList[ind].attr_name = attr_name;
        newList[ind].price_text = price_text;
        newList[ind].title = name + (price !== 0 ? (' : ' + price_text) : '');
        setValidListItem(newList);
        setTotalPrice(sumCalculate(validityRatio) + productPrice)
        setSum(sumCalculate(validityRatio));
        setAttrSt(newList)
        if (
            !JSON.parse(localStorage.getItem('product')) &&
            !JSON.parse(localStorage.getItem('validList')) &&
            !JSON.parse(localStorage.getItem('sum'))
        )
            localStorage.removeItem('attrList');
    };
    let valid_store = null;
    let attr_store = null;
    let sum_store = null;
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const idParams = queryParams.get('id'); // Get the 'id' value
        if (idParams) {
            setIsSetId(true)
            getServiceOrder(idParams, (isOk, data) => {
                if (isOk) {
                    setOrder(data)
                    setLoading(false);
                    setProduct(() => [
                        {
                            product_id: data.product.id,
                            title: data.product.title,
                            cat_id: data.product.cat_id
                        }
                    ]);
                    setLocale(data?.location ?? "fa");
                    setValidList(data?.validity_list ?? []);
                    setAttrList(data?.attribute_list ?? []);
                    setAttrLen(data?.attribute_list.length ?? 0);
                    setProductPrice(data?.validity_list[0] ? data.validity_list[0].price : 0)
                    if (JSON.parse(localStorage.getItem('validList'))) {
                        valid_store = JSON.parse(localStorage.getItem('validList'));
                        setProductPrice(valid_store[0]?.price)
                    }
                    setValidListItem1(valid_store ? valid_store : data?.validity_list)
                    setValidSt(valid_store ? valid_store : data?.validity_list);
                    if (JSON.parse(localStorage.getItem('attrList'))) {
                        attr_store = JSON.parse(localStorage.getItem('attrList'));
                        setValidListItem(attr_store);
                        setAttrSt(attr_store);
                    }
                    if (JSON.parse(localStorage.getItem('sum'))) {
                        sum_store = JSON.parse(localStorage.getItem('sum'));
                        setSum(sum_store);
                    }
                    if (valid_store && sum_store) {
                        const f = data.validity_list.find((item) => item.id === valid_store[0].validity_id)
                        setTotalPrice(sum_store + f.price)
                    } else {
                        setTotalPrice((sum ? sum : 0) + data?.validity_list[0]?.price)
                    }
                    //------------------------

                    const array1 = [];
                    const array2 = [];
                    if (
                        !validListItem1[0].title &&
                        !validListItem1[0].price &&
                        !cardStorage()
                    ) {
                        array1.push({
                            validity_id: (data?.validity_list[0] ? data.validity_list[0].id : 0),
                            title: (data?.validity_list[0] ? data.validity_list[0].title : 0),
                            price: (data?.validity_list[0] ? data.validity_list[0].price : 0),
                            ratio: (data?.validity_list[0] ? data.validity_list[0].ratio : 1),
                        });
                        setProductPrice(data?.validity_list[0] ? data.validity_list[0].price : 0)
                        setTotalPrice(sum + (data?.validity_list[0] ? data.validity_list[0].price : 0))
                        setValidListItem1(array1);
                    }
                    if ([...validListItem].length === 0 && !cardStorage()) {
                        for (let i = 0; i < data.attribute_list.length; i++) {
                            array2.push({
                                id: data.attribute_list[i].attr_id,
                                option_id: data.attribute_list[i].options[0].id,
                                title:
                                    data.attribute_list[i].options[0].title +
                                    (data.attribute_list[i].options[0].price !== 0 ? (' : ' + data.attribute_list[i].options[0].price_text) : ''),
                                attr_name: data.attribute_list[i].title,
                                price: data.attribute_list[i].options[0].price,
                                name: data.attribute_list[i].options[0].title,
                                price_text: data.attribute_list[i].options[0].price_text
                            });
                        }
                        const sum1 = array2 ? array2.reduce((accumulator, object) => {
                            return accumulator + (object.price * validityRatio);
                        }, 0) : 0;
                        setSum(sum1);
                        setTotalPrice(sum1 + (data?.validity_list[0] ? data.validity_list[0].price : 0))
                        setValidListItem(array2);
                        setAttrSt(array2);
                    }
                } else {
                    setLoading(false);
                    setIsSetId(false)
                    setAlertMassage(data)
                    alertStore.AddAlert({
                        key: '400',
                        message: data,
                        severity: 'error',
                        auto_hide: true
                    });
                }
            });
            // if (location.state.locale) setLocale(location.state.locale)
            // else setLocale('ir');
        }
        else {
            setIsSetId(false)
            setAlertMassage("آدرس URL نادرست است لطفا آدرس را به درستی وارد نمایید.")
        }
    }, []);
    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    {isSetId ? (
                        <div className="row mt-3">
                            <div className="col-12 col-lg-10 mx-auto">
                                <h3 className="pt-50 mb-5 d-flex align-items-center">
                                    <div className="service-icon bg-danger ml-2">
                                        <p className="m-0">
                                            <i className="text-white bi bi-gear f-12"/>
                                        </p>
                                    </div>
                                    <span className="f-13 ms-3">پیکربندی نهایی</span>
                                </h3>
                                <div className="cart_detail pb-50">
                                    <div className="cart__list">
                                        <ul className="p-0 w-100 mb-4">
                                            <li className="main__cart__list border-primary border border-dashed">
                                                <div className="produst__title">
                                                    <div className="product__status bg-primary">
                          <span className="m-0 f-22 line-height-2">
                            <i className="text-white bi bi-hdd-network f-1"/>
                          </span>
                                                    </div>
                                                    <Box
                                                        className="d-flex flex-column"
                                                        sx={{
                                                            paddingRight: {lg: 0, xs: '80px'},
                                                            width: 'calc(100% - 80px)',
                                                            fontSize: {lg: '1.5rem', xs: '1rem'}
                                                        }}
                                                    >
                          <span className="f-bold">
                            <span className={'me-1'}>سرور مجازی</span>

                              {product && <span>{product[0].title}</span>}
                              <span className={'d-lg-inline d-none'}>
                              {locale === 'ir' ? ' - ایران' : ' - اروپا'}
                            </span>
                          </span>
                                                        <div className="d-flex flex-column align-items-center"></div>
                                                    </Box>
                                                    <div className="produst__action"></div>
                                                    <div className="delete__from_cart ">
                                                        <img
                                                            className="menu-titile-icon"
                                                            src={
                                                                locale === 'ir'
                                                                    ? '/assets/media/svg/iran-flag.svg'
                                                                    : '/assets/media/svg/european-flag.svg'
                                                            }
                                                            alt="SVG"
                                                            width={'60px'}
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <h6 className="pt-4 mb-5 d-flex align-items-center">
                                    <div className="service-icon bg-danger ml-2">
                                        <p className="m-0">
                                            <i className="text-white bi bi-tools f-1"/>
                                        </p>
                                    </div>
                                    <span className="f-16 ms-3">تنظیمات قابل پیکربندی</span>
                                </h6>

                                <div className="cart_detail pb-50">
                                    <div className="cart__list">
                                        <ul className="p-0 w-100 mb-4">
                                            {/*دوره زمانی*/}
                                            <li className="main__cart__list border-primary border border-dashed">
                                                <div className="produst__title p-0">
                                                    <div className="product__status bg-primary">
                          <span className="m-0 line-height-2">
                            <i className="text-white bi bi-hourglass-split f-25"/>
                          </span>
                                                    </div>
                                                    <Dropdown className={'d-flex flex-1'}>
                                                        <Dropdown.Toggle
                                                            variant=""
                                                            id="dropdown-basic"
                                                            style={{
                                                                width: '100%',
                                                                height: '80px',
                                                                paddingRight: '90px',
                                                                paddingLeft: '25px'
                                                            }}
                                                            className={'d-flex align-items-center justify-content-between w-100 mb-0'}
                                                        >
                                                            <Box
                                                                className="d-flex flex-column"
                                                                sx={{
                                                                    paddingRight: {lg: 0, xs: '0'},
                                                                    fontSize: {lg: '1.3rem', xs: '1rem'}
                                                                }}
                                                            >
                                                                <span className="f-bold">دوره زمانی</span>
                                                            </Box>
                                                            <div className="produst__action h-auto">
                                                                <div className="price text-left">
                                                                    <div className="">
                                                                        <p className="text-primary f-12 mb-0">
                                                                            {valid_store ? validListItem1 ? validListItem1[0]?.title : ''
                                                                                : validSt ? validSt[0]?.title : ''}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            {validList &&
                                                                validList.map((validItem, index) => (
                                                                    <Dropdown.Item
                                                                        key={index}
                                                                        onClick={(e) => {
                                                                            setValidityRatio(validItem.ratio)
                                                                            validItemClick(
                                                                                e,
                                                                                validItem.id,
                                                                                validItem.price,
                                                                                validItem.ratio
                                                                            )
                                                                        }
                                                                        }
                                                                        href=""
                                                                    >
                                                                        {validItem.title}
                                                                    </Dropdown.Item>
                                                                ))}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </li>

                                            {attrList &&
                                                attrList.map((attrItem, index) => (
                                                    <li
                                                        key={index}
                                                        className="main__cart__list border-primary border border-dashed"
                                                    >
                                                        <div className="produst__title p-0">
                                                            <div className="product__status bg-primary">
                              <span className="m-0 line-height-2">
                                <i className={classIcon(attrItem.title)}/>
                              </span>
                                                            </div>
                                                            <Dropdown className={'d-flex flex-1'}>
                                                                <Dropdown.Toggle
                                                                    variant=""
                                                                    id={'dropdown-basic' + `${index}`}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '80px',
                                                                        paddingRight: '90px',
                                                                        paddingLeft: '25px'
                                                                    }}
                                                                    className={'d-flex align-items-center justify-content-between w-100 mb-0'}
                                                                >
                                                                    <Box
                                                                        className="d-flex flex-column"
                                                                        sx={{
                                                                            paddingRight: {lg: 0, xs: '80px'},
                                                                            fontSize: {lg: '1.3rem', xs: '1rem'}
                                                                        }}
                                                                    >
                                                                        <span className="f-bold">{attrItem.title}</span>
                                                                    </Box>
                                                                    <div className="produst__action h-auto">
                                                                        <div className="price text-left">
                                                                            {attr_store ? ( validListItem?.find( (item) => item.id === attrItem.attr_id
                                                                            ) && (
                                                                                <div className={ 'd-flex f-12 text-primary flex-wrap' }>
    <span>
      { validListItem?.find( (item) => item.id === attrItem.attr_id ).name }
    </span>
                                                                                    <span>
      {(() => { const matchedItem = validListItem.find((item) => item.id ===
          attrItem.attr_id); return matchedItem && matchedItem.price !== 0 ? (
          <>
        <span className="mx-1">
          :
        </span>
              {matchedItem.price}
          </>
      ) : null; })()}
    </span>
                                                                                </div>
                                                                            ) ) : (
                                                                                <div className={ 'd-flex f-12 text-primary flex-wrap' }>
    <span className={index}>
      {attrSt && attrSt[index].title}
    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    {attrItem.options &&
                                                                        attrItem.options.map(
                                                                            (validOption, index) => (
                                                                                <Dropdown.Item
                                                                                    key={index}
                                                                                    href=""
                                                                                    onClick={(e) =>
                                                                                        attrItemClick(
                                                                                            e,
                                                                                            attrItem.attr_id,
                                                                                            validOption.id,
                                                                                            attrItem.title,
                                                                                            validOption.title,
                                                                                            validOption.price,
                                                                                            validOption.price_text
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={`d-flex ${attrItem.attr_id !== 2 ? 'direction-rtl' : 'direction-ltr'} text-right`}
                                                                                    >
                                                                                        <span>{validOption.title}</span>
                                                                                        <span>
                                              {(attrItem.attr_id !== 2 && attrItem.attr_id !== 4 && attrItem.attr_id !== 5) && ' : ' + validOption.price_text}
                                            </span>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            )
                                                                        )}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="cart_detail pb-50w">
                                    <div
                                        className="cart-box shadow-sm"
                                        style={{border: '1px solid #eaeaea'}}
                                    >
                                        <div className="total-price final-price mb-3 px-0">
                    <span className={'text-dark f-12'}>
                      مجموع هزینه پرداختی
                    </span>
                                            <span className={'text-dark f-12'}>
                      <b id="all_pay f-11">
                        {numSeperator(totalPrice)}
                      </b>
                      <b className={'text-dark ms-1'}>تومان</b>
                    </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center border-none">
                                            <Link
                                                to={
                                                    '/services'
                                                }
                                                className="btn btn-secondary ponline-payment mx-0"
                                            >
                                                انصراف
                                            </Link>
                                            <Link
                                                to={{
                                                    pathname: '/card'
                                                    // state: {
                                                    //     valid_list: [...validListItem1],
                                                    //     attr_list: [...validListItem],
                                                    //     product_info: [...product],
                                                    //     sum_info: sum
                                                    // }
                                                }}
                                                className="btn btn-primary submit_button ponline-payment mx-0"
                                                onClick={saveInfo}
                                            >
                                                ادامه
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={'card'}>
                                <div className={'card-body'}>
                                    <div className={'px-4 py-3 mb-5 rounded-lg d-flex align-items-center flex-lg-row border-1 justify-content-between flex-column text-danger'} style={{
                                        background: 'rgba(248, 40, 90, .2)',
                                        borderColor: '#F8285A'
                                    }}>
                                        {alertMassage}
                                    </div>
                                    <div className={'row'}>
                                        <div className={'col-12'}>
                                            <h1 className={'mb-5'}>لینک های  مرتبط</h1>
                                            <hr/>
                                        </div>
                                        {Data.sidebar.servers_category.map((category, index) => (
                                            <div className="col-lg-3 col-6" key={index}>
                                                <Link to={category.url} className={'p-4 border text-primary d-block mb-4 text-center rounded'} style={{
                                                    fontSize: 'medium'
                                                }}
                                                >
                                                    <span className="">{category.name}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                </>
            )}
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    );
};

export default ServerOrder